import React from "react";

type IconProps = React.SVGProps<SVGSVGElement>;

const base: IconProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

export const TrendIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M3 17l5-6 4 4 5-7 4 5" />
  </svg>
);

export const BarsIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M5 20V10M12 20V4M19 20v-7" />
  </svg>
);

export const ChatIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M21 15a2 2 0 0 1-2 2H8l-4 4V6a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2z" />
  </svg>
);

export const PinIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 21s7-6.3 7-11a7 7 0 1 0-14 0c0 4.7 7 11 7 11z" />
    <circle cx="12" cy="10" r="2.4" />
  </svg>
);

export const SlidersIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M4 7h16M4 12h10M4 17h6" />
  </svg>
);

export const CheckIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const CloseIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const SendIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

export const GeoIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3.2" />
    <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
    <circle cx="12" cy="12" r="8" />
  </svg>
);

export const InfoIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v5M12 17h.01" />
  </svg>
);

export const ClockIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 7.6v4.8l2.8 1.7" />
    <circle cx="12" cy="12" r="8.6" />
  </svg>
);

export const WalletIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M3 8h16a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 8V6a2 2 0 0 1 2-2h11" />
    <path d="M17 13h.01" />
  </svg>
);

export const ArrowUpIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M12 3v18M5 10l7-7 7 7" />
  </svg>
);

export const ChevronDownIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);

export const LockIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <rect x="4" y="11" width="16" height="10" rx="2.6" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export const BoxIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M4.5 7.5 12 3.6l7.5 3.9v9L12 20.4 4.5 16.5zM4.5 7.5 12 11.4l7.5-3.9M12 11.4v9" />
  </svg>
);

export const MoneyIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M4 9.6c0-1.4 1.1-2.5 2.5-2.5h11c1.4 0 2.5 1.1 2.5 2.5v7.4c0 1.4-1.1 2.5-2.5 2.5h-11A2.5 2.5 0 0 1 4 17zM4 9.9V7.2c0-1.2.9-2.2 2-2.4l9-1.2M17 14h.02" />
  </svg>
);

export const RateIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M3.5 16.5 8.4 11l3.6 3.4L19 6.6M14.6 6.6H19v4.4" />
  </svg>
);

export const RoadIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="M9 3.6v3M9 10.6v3M9 17.6v3M15 3.6v3M15 10.6v3M15 17.6v3" />
  </svg>
);

export const StarIcon = (p: IconProps) => (
  <svg {...base} {...p}>
    <path d="m12 3.4 2.6 5.4 5.9.8-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.6l5.9-.8z" />
  </svg>
);
